<template>
  <section class="main">
    <div class="header">
      <img
        src="https://hzwimspic-1251601690.image.myqcloud.com/f6bd7ae9-48b4-4647-aba2-fb1b9733af33"
      />
      <span class="title">{{ insuranceInfo.title }}</span>
      <span class="sub-title">{{ insuranceInfo.subtitle }}</span>
      <p v-if="insuranceInfo.tag" class="tag">
        <span>{{ insuranceInfo.tag }}</span>
      </p>
    </div>
    <div class="product">
      <div v-if="insuranceInfo.adult && showAdult" class="product-content">
        <p class="title">{{ insuranceInfo.adult.productTitle }}</p>
        <div class="content">
          <p class="name" @click="showDetailPopup(false)">
            {{ insuranceInfo.adult.productName }}
          </p>
          <img
            class="arrow"
            src="@/assets/images/icon_arrow_right.png"
            @click="showDetailPopup(false)"
          />
          <p class="price">¥0</p>
          <img
            class="radio"
            :src="
              selectAdultList.length > 0
                ? require('@/assets/images/icon_insuring_selected.png')
                : require('@/assets/images/icon_insuring_normal.png')
            "
            @click.stop="select(insuranceInfo.adult)"
          />
        </div>
        <p class="selling">{{ insuranceInfo.adult.productSelling }}</p>
        <div v-if="selectAdultList.length > 0" class="select-person">
          <div class="result">
            <div>
              <p>领取人</p>
              <span>
                {{ selectAdultList.map(x => x.name).join('、') }}共{{
                  selectAdultList.length
                }}人领取
              </span>
            </div>
            <div class="date">
              <p>有效期</p>
              <span>{{ startTime }}至{{ endTime }}</span>
            </div>
          </div>
          <p @click.stop="select(insuranceInfo.adult)">修改</p>
        </div>
      </div>
      <div v-if="insuranceInfo.child && showChild" class="product-content">
        <p class="title">{{ insuranceInfo.child.productTitle }}</p>
        <div class="content">
          <p class="name" @click="showDetailPopup(true)">
            {{ insuranceInfo.child.productName }}
          </p>
          <img
            class="arrow"
            src="@/assets/images/icon_arrow_right.png"
            @click="showDetailPopup(true)"
          />
          <p class="price">¥0</p>
          <img
            class="radio"
            :src="
              selectChildList.length > 0
                ? require('@/assets/images/icon_insuring_selected.png')
                : require('@/assets/images/icon_insuring_normal.png')
            "
            @click.stop="select(insuranceInfo.child)"
          />
        </div>
        <p class="selling">{{ insuranceInfo.child.productSelling }}</p>
        <div v-if="selectChildList.length > 0" class="select-person">
          <div class="result">
            <div>
              <p>领取人</p>
              <span>
                {{ selectChildList.map(x => x.name).join('、') }}共{{
                  selectChildList.length
                }}人领取
              </span>
            </div>
            <div class="date">
              <p>有效期</p>
              <span>{{ startTime }}至{{ endTime }}</span>
            </div>
          </div>
          <p @click.stop="select(insuranceInfo.child)">修改</p>
        </div>
      </div>
    </div>
    <van-popup
      v-model="showDetail"
      position="bottom"
      round
      closeable
      :style="{ height: '60%' }"
    >
      <div class="detail-wrapper">
        <h3>保障详情</h3>
        <div class="content">
          <img v-for="item in imgs" :key="item" :src="item" />
          <div class="menu_wkBox_back_box"></div>
        </div>
      </div>
    </van-popup>
  </section>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import { mapState, mapMutations } from 'vuex'
import { InsuranceType } from '@/config'
import { Popup } from 'vant'
const { mapState: mapStateNs, mapMutations: mapMutationNs } =
  createNamespacedHelpers('insurance')
export default {
  props: {
    type: {
      type: Number,
      default: InsuranceType.ADULT
    }
  },
  components: {
    [Popup.name]: Popup
  },
  data() {
    return {
      detailImgs: '',
      showDetail: false
    }
  },
  watch: {
    //当数据源更新数据时 被选中的也需要更新
    travelPersonList() {
      if (this.guardianInfo.tpid) {
        const item = this.travelPersonList.find(
          b => b.tpid === this.guardianInfo.tpid
        )
        if (item) this.setGuardianInfo(item)
      }
      if (this.selectAdultList && this.selectAdultList.length > 0) {
        this.setAdultPersonList(
          this.selectAdultList
            .filter(x => {
              const item = this.travelPersonList.find(b => b.tpid === x.tpid)
              return item
            })
            .map(d => {
              const item = this.travelPersonList.find(b => b.tpid === d.tpid)
              return item
            })
        )
      }
      if (this.selectChildList && this.selectChildList.length > 0) {
        this.setChildPersonList(
          this.selectChildList
            .filter(x => {
              const item = this.travelPersonList.find(b => b.tpid === x.tpid)
              return item
            })
            .map(d => {
              const item = this.travelPersonList.find(b => b.tpid === d.tpid)
              return item
            })
        )
      }
    }
  },
  computed: {
    ...mapStateNs([
      'insuranceInfo',
      'selectPriceCalendarDate',
      'supportPriceCalendar',
      'travelPersonList',
      'selectAdultList',
      'selectChildList',
      'guardianInfo',
      'startTime',
      'endTime'
    ]),
    imgs() {
      return this.detailImgs.split(';')
    },
    showAdult() {
      return (
        this.type === InsuranceType.ADULT || this.type === InsuranceType.ALL
      )
    },
    showChild() {
      return (
        this.type === InsuranceType.CHILD || this.type === InsuranceType.ALL
      )
    }
  },
  methods: {
    ...mapMutations(['changeView', 'setActionHeader']),
    ...mapMutationNs([
      'setCurrentProduct',
      'setAdultPersonList',
      'setChildPersonList',
      'setGuardianInfo'
    ]),
    select(product) {
      if (this.supportPriceCalendar && !this.selectPriceCalendarDate) {
        this.$$toast('请选择出游日期后再领取保险')
        return
      }
      this.setCurrentProduct(product)
      this.changeView('addUserForInsurance')
      this.setActionHeader({
        show: false
      })
      this.$router.push({
        query: {
          ...this.$route.query,
          action: true,
          viewName: 'addUserForInsurance'
        }
      })
    },
    showDetailPopup(isChild) {
      if (isChild) {
        this.detailImgs = this.insuranceInfo.child.productImgs || ''
      } else {
        this.detailImgs = this.insuranceInfo.adult.productImgs || ''
      }
      this.showDetail = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.main {
  background-color: white;
  border-radius: rem(16px);
}

.header {
  width: 100%;
  height: rem(78px);
  position: relative;
  background: url(https://hzwimspic-1251601690.image.myqcloud.com/6d9a90ee-8c59-4d4b-8baa-21588b982219)
    no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  padding-left: rem(24px);

  > img {
    width: rem(30px);
  }
  .title {
    color: #121212;
    font-weight: 500;
    @include ellicpsis;
    max-width: rem(160px);
    margin-left: rem(12px);
    font-size: rem(30px);
  }
  .sub-title {
    color: #fe8200;
    font-size: rem(22px);
    @include ellicpsis;
    max-width: rem(360px);
    margin-left: rem(48px);
  }
  .tag {
    position: absolute;
    top: rem(2px);
    right: 0;
    display: flex;
    align-content: center;
    padding: 0 rem(10px);
    border-radius: rem(16px) rem(16px) 0px rem(16px);
    background: linear-gradient(270deg, #ff5900 0%, #ff2e2e 100%);
    span {
      color: #ffffff;
      font-size: rem(20px);
      transform: scale(0.9);
    }
  }
}
.product {
  margin-top: rem(10px);
  .product-content {
    border-bottom: rem(1px) #f4f4f4 solid;
    padding: rem(24px) 0;
    margin: 0 rem(25px);
    &:last-child {
      border-width: 0;
    }
    .title {
      color: #000000;
      font-weight: 600;
      font-size: rem(26px);
    }
    .content {
      display: flex;
      align-items: center;
      margin-top: rem(12px);

      .name {
        color: #121212;
        font-size: rem(26px);
        max-width: rem(530px);
        @include ellicpsis;
      }
      .arrow {
        width: rem(20px);
        height: rem(20px);
        margin-left: rem(8px);
      }
      .price {
        color: #ff5900;
        flex: 1;
        text-align: right;
        font-weight: 500;
        font-size: rem(26px);
      }
      .radio {
        width: rem(36px);
        margin-left: rem(16px);
        height: rem(36px);
      }
    }

    .selling {
      color: #999;
      margin-top: rem(8px);
      font-size: rem(24px);
    }
    .select-person {
      border-radius: rem(8px);
      background: #f7f7f7;
      padding: rem(24px);
      display: flex;
      align-items: center;
      margin-top: rem(24px);
      overflow: hidden;
      .result {
        flex: 1;
        div {
          display: flex;
          p {
            color: #666666;
            flex-shrink: 0;
            font-size: rem(26px);
            width: rem(110px);
          }
          span {
            color: #000000;
            font-size: rem(26px);
          }
        }
        .date {
          margin-top: rem(20px);
        }
      }
      > p {
        color: #348be6;
        margin-left: rem(12px);
        font-size: rem(26px);
      }
    }
  }
}
.detail-wrapper {
  background: url(https://hzwimspic-1251601690.image.myqcloud.com/206ec88f-59a1-4e4f-a711-f88291d3134f)
    no-repeat;
  background-size: 100% auto;
  overflow: hidden;
  h3 {
    height: rem(112px);
    text-align: center;
    line-height: rem(112px);
    color: #121212;
    font-weight: 500;
    font-size: rem(32px);
  }
  .content {
    height: calc(60vh - 1.12rem);
    overflow-y: scroll;
    img {
      width: 100%;
    }
  }
}
</style>
